exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.ui-spinner svg {\n    width: 100%;\n    height: 100%;\n    fill: var(--cl-blue);\n    animation: ui-spinner 0.5s linear infinite;\n}\n@keyframes ui-spinner{\n100% {\n        transform: rotate(360deg);\n}\n}\n\n", ""]);
